module.exports = __webpack_public_path__ + "static/media/fribourg.e8e6ded7.jpg";